/**
 * WorkOS JWT access token for authenticated API calls (Platform API, Core API, SSE).
 */

let getAccessTokenFn: (() => Promise<string | null>) | null = null;

export function initializeAuth(getAccessToken: () => Promise<string | null>) {
  getAccessTokenFn = getAccessToken;
}

function getE2EAccessToken(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem('e2e:access-token');
}

/**
 * Get the current access token for authenticated API calls.
 * Returns null if not initialized or token unavailable.
 */
export async function getAccessToken(): Promise<string | null> {
  const e2eToken = getE2EAccessToken();
  if (e2eToken) {
    return e2eToken;
  }
  if (!getAccessTokenFn) {
    return null;
  }
  return getAccessTokenFn();
}

export { getE2EAccessToken };
